import React from 'react'

const Transaction = (props) => {
  return (
    <tbody>

        <tr>
        <td>{props.currency}</td>
        <td>{props.price} </td>
        <td>{props.owner} </td>
        <td>{props.negotiation} </td>
        <td>{props.action} </td>
        </tr>

    </tbody>
  )
}

export default Transaction